module.exports = __webpack_public_path__ + "img/CtrlRoom_bg.055b9489.png";